export default "__VITE_ASSET__B_I8lWl___"